import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()

window.activeStorage = ActiveStorage
